module.exports = __webpack_public_path__ + "img/mobilelab_driving.623af23d.svg";